import { AuditContext } from "../../schema/types/auditctx/entity";
import { linksOf } from "../../services/cpln";
import { parseLink } from "../../utils/linkParser/linkParser";

export const auditctxHelpers = {
  getStatusText(auditctx: AuditContext) {
    if (auditctx.status) {
      const text: string[] = [];
      for (let key of Object.keys(auditctx.status).slice().sort()) {
        const value = auditctx.status[key];
        text.push(`${key}: ${value}`);
      }
      return text;
    }
    return "Status not found";
  },
};

export interface AuditContextTableItem extends AuditContext {
  selfLink: string;
}

interface GetAuditContextTableItemProps {
  link?: string;
  name?: string;
  item?: AuditContext;
}
export function getAuditContextTableItem({ link, name, item }: GetAuditContextTableItemProps): AuditContextTableItem {
  if (item) {
    const selfLink = linksOf(item).self!;

    return {
      ...item,
      selfLink: selfLink,
    };
  }

  if (link) {
    const { name } = parseLink(link, { useInputCtx: true });

    return {
      kind: "auditctx",
      name: name,
      selfLink: link,
      links: [{ rel: "self", href: link }],
      created: "",
      description: "",
      id: "",
      origin: "default",
      lastModified: "",
      tags: {},
      version: 1,
    };
  }

  // assume name
  return {
    kind: "auditctx",
    name: name!,
    selfLink: `TODO test if this breaks`,
    links: [],
    created: "",
    description: "",
    id: "",
    origin: "default",
    lastModified: "",
    tags: {},
    version: 1,
  };
}
